import SearchSettingsService from '../../services/searchSettings'

export const state = {}

export const mutations = {}


export const getters = {}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {},

  // eslint-disable-next-line no-unused-vars
  createSynonym ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.createSynonym(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateSynonym ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateSynonym(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  deleteSynonym ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.deleteSynonym(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  getSynonyms ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.getSynonyms(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateSearchableProperties ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateSearchableProperties(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars  
  updateFilterableProperties ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateFilterableProperties(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateStopWords ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateStopWords(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateTypoTolerance ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateTypoTolerance(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateFacets ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateFacets(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateFacetOptions ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateFacetOptions(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateFacetValueOrder ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateFacetValueOrder(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  getFacetValues ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.getFacetValues(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  getConfigurations ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.getConfigurations(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateRankingRules ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateRankingRules(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateRankingOptions ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateRankingOptions(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateRankBoostRules ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateRankBoostRules(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateFilterRules ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateFilterRules(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateReRanking ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateReRanking(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateHasSkuSearchByList ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateHasSkuSearchByList(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateInternalIps ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateInternalIps(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  getClientIp ({ commit }) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.getClientIp().then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateMinInstaLength ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateMinInstaLength(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateRules ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateRules(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updatePostFilterConfig ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updatePostFilterConfig(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateSearchInstructions ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateSearchInstructions(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateAdditionalAttributes ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateAdditionalAttributes(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateQueryRewriteRulesProduct ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateQueryRewriteRulesProduct(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateQueryRewriteRulesOcasion ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateQueryRewriteRulesOcasion(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateExtendedFields ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateExtendedFields(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateKeywordInstructions ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateKeywordInstructions(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateImageSearchInstructions ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateImageSearchInstructions(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateNextSearchBlockedTerms ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateNextSearchBlockedTerms(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateBoosting ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateBoosting(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateAutoFilterExcludedFacets ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateAutoFilterExcludedFacets(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateRetrievalWeights ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateRetrievalWeights(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateMatchingRules ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateMatchingRules(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateQueryRewriteAdvanced ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateQueryRewriteAdvanced(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  updateRerankerFields ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateRerankerFields(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  regenerateImageKeywords ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.regenerateImageKeywords(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },

  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line no-unused-vars
  updateSearchFlags ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateSearchFlags(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  updateValueNormalization ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateValueNormalization(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  updateProductEnrichment ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateProductEnrichment(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  updateEnableSearch ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateEnableSearch(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  getSearchInsights ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.getSearchInsights(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  },
  // eslint-disable-next-line no-unused-vars
  updateLookSearch ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      SearchSettingsService.updateLookSearch(payload).then(response => {
        resolve(response.data)
      })
      .catch(error => { reject(error) })
    })
  }

}
